import { module } from 'modujs'

const MAP_HEIGHT_RATIO = 1031 / 614
const MAP_HEIGHT_MINUS = 700 / 1031

export default class extends module {
    constructor(m) {
        super(m)

        // Binding
        this.onResizeBind = this.onResize.bind(this)
        this.onFontsLoadedBind = this.onFontsLoaded.bind(this)

        // UI
        this.$el = this.$('element')[0]
        this.$area = this.$('area')[0]
        this.$heroMarker = this.$('heroMarker')[0]

        // Data
        this.extremeCoords = {
            N: {
                long: -74.23229167053594,
                lat: 83.111389,
            },
            S: {
                long: -82.68222,
                lat: 41.681389,
            },
            E: {
                long: -52.61944,
                lat: 47.523611,
            },
            W: {
                long: -141.00194,
                lat: 60.306389,
            }
        }

        this.heroMarkerCoords = {
            x: 0,
            y: 0
        }

        // Current data
        this.lat = this.getData('lat')
        this.long = this.getData('long')
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.bindEvents()

        if (window.isFontsLoaded) {
            this.onFontsLoaded()
        }
    }

    destroy() {
        super.destroy()
        this.unbindEvents()
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        window.addEventListener("resizeEnd", this.onResizeBind)
        window.addEventListener("fontsLoaded", this.onFontsLoadedBind)
    }

    unbindEvents() {
        window.removeEventListener("resizeEnd", this.onResizeBind)
        window.removeEventListener("fontsLoaded", this.onFontsLoadedBind)
    }

    ///////////////
    // Callbacks
    ///////////////
    onResize() {
        this.computeMapMarker()
        this.translateMap()
    }

    onFontsLoaded() {
        this.computeMapMarker()
        this.translateMap()
    }

    ///////////////
    // Methods
    ///////////////
    computeMapMarker() {
        this.heroMarkerCoords = {
            x: this.$heroMarker.offsetLeft + this.$heroMarker.offsetWidth / 2,
            y: this.$heroMarker.offsetTop + this.$heroMarker.offsetHeight / 2
        }
    }

    translateMap() {
        if (!this.lat || !this.long) return

        const { x, y } = this.convertGeoToPixel(this.lat, this.long)

        const computedX = this.heroMarkerCoords.x - x
        const computedY = this.heroMarkerCoords.y - (y - (MAP_HEIGHT_MINUS * this.$area.offsetHeight))

        this.$el.style.transform = `translate3d(${computedX}px, ${computedY}px, 0)`
    }

    // https://stackoverflow.com/questions/2103924/mercator-longitude-and-latitude-calculations-to-x-and-y-on-a-cropped-map-of-the
    convertGeoToPixel($lat, $lon) {
        let lon = $lon
        let lat = $lat
        const mapWidth = this.$area.offsetWidth;
        const mapHeight = this.$area.offsetHeight * MAP_HEIGHT_RATIO;

        const mapLonLeft = this.extremeCoords.W.long;
        const mapLonRight = this.extremeCoords.E.long;
        const mapLonDelta = mapLonRight - mapLonLeft;

        const mapLatBottom = this.extremeCoords.S.lat;
        const mapLatBottomDegree = mapLatBottom * Math.PI / 180;

        const $x = (lon - mapLonLeft) * (mapWidth / mapLonDelta);

        lat = lat * Math.PI / 180;
        const worldMapWidth = ((mapWidth / mapLonDelta) * 360) / (2 * Math.PI);
        const mapOffsetY = (worldMapWidth / 2 * Math.log((1 + Math.sin(mapLatBottomDegree)) / (1 - Math.sin(mapLatBottomDegree))));
        const $y = mapHeight - ((worldMapWidth / 2 * Math.log((1 + Math.sin(lat)) / (1 - Math.sin(lat)))) - mapOffsetY);

        return { x: $x, y: $y };
    }
}